(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novariv-community"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-community-filters]').forEach((filters) => {
    if (filters.dataset.communityReady === 'true') return;

    const section = filters.closest('.novariv-community');
    if (!section) return;

    filters.dataset.communityReady = 'true';
    const buttons = filters.querySelectorAll('[data-community-filter]');
    const cards = section.querySelectorAll('[data-community-card]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const selectedFilter = button.dataset.communityFilter;

        buttons.forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });

        cards.forEach((card) => {
          card.hidden = selectedFilter !== 'all' && card.dataset.communityCard !== selectedFilter;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novariv-footer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-novariv-language-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const selectedOption = select.options[select.selectedIndex];
      const nextRoot = selectedOption.dataset.rootUrl || '/';
      const currentRoot = select.dataset.currentRoot || '/';
      const currentPath = window.location.pathname;
      const normalizedCurrentRoot = currentRoot === '/' ? '' : currentRoot.replace(/\/$/, '');
      const normalizedNextRoot = nextRoot === '/' ? '' : nextRoot.replace(/\/$/, '');
      const pathWithoutLocale = normalizedCurrentRoot && currentPath.startsWith(`${normalizedCurrentRoot}/`)
        ? currentPath.slice(normalizedCurrentRoot.length)
        : currentPath === normalizedCurrentRoot
          ? '/'
          : currentPath;

      window.location.assign(`${normalizedNextRoot}${pathWithoutLocale}${window.location.search}${window.location.hash}`);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novariv-preaccess-overlay"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('novariv-preaccess-overlay')) {
    customElements.define('novariv-preaccess-overlay', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.closeButton = this.querySelector('[data-nv-access-close]');
        this.success = this.querySelector('[data-nv-signup-success]');
        this.error = this.querySelector('.nv-access-form__error');
        this.closeButton?.addEventListener('click', () => this.dismiss(), { signal: this.abort.signal });
        document.addEventListener('keydown', event => this.onKeydown(event), { signal: this.abort.signal });

        if (this.success || this.error) {
          if (this.success) {
            this.classList.add('nv-access-overlay--success');
            const dialog = this.querySelector('[role="dialog"]');
            dialog?.removeAttribute('aria-labelledby');
            dialog?.setAttribute('aria-label', this.success.textContent.trim());
          }
          this.open(true);
          if (this.success) {
            this.success.focus({ preventScroll: true });
          }
          return;
        }
        if (this.wasDismissed()) return;
        const clothes = document.querySelector('novariv-release-strip');
        if (!clothes) return;
        this.readyAt = performance.now() + (Number(this.dataset.delay) || 1200);
        const initialScrollY = window.scrollY;
        const checkClothes = () => {
          const bounds = clothes.getBoundingClientRect();
          if (Math.abs(window.scrollY - initialScrollY) < 48 || bounds.top > innerHeight * .62 || bounds.bottom < 0) return;
          window.removeEventListener('scroll', checkClothes);
          this.openAtClothes();
        };
        window.addEventListener('scroll', checkClothes, { signal: this.abort.signal, passive: true });
      }

      disconnectedCallback() {
        this.abort?.abort();
        window.clearTimeout(this.openTimer);
      }

      openAtClothes() {
        this.openTimer = window.setTimeout(() => this.open(), Math.max(0, this.readyAt - performance.now()));
      }

      wasDismissed() {
        try {
          if (sessionStorage.getItem('novariv-access-closed') === '1') return true;
          const closedAt = Number(localStorage.getItem('novariv-access-closed-at'));
          return closedAt > 0 && Date.now() - closedAt < (Number(this.dataset.dismissDays) || 30) * 86400000;
        } catch (_) { return false; }
      }

      open(force = false) {
        if (!this.hidden || (!force && this.wasDismissed())) return;
        this.previousFocus = document.activeElement;
        this.hidden = false;
        this.closeButton?.focus({ preventScroll: true });
      }

      dismiss(restoreFocus = true) {
        if (this.hidden) return;
        this.hidden = true;
        try {
          sessionStorage.setItem('novariv-access-closed', '1');
          localStorage.setItem('novariv-access-closed-at', String(Date.now()));
        } catch (_) { /* Storage may be unavailable; keep the overlay closed in this page. */ }
        if (restoreFocus) {
          const target = this.previousFocus instanceof HTMLElement && this.previousFocus !== document.body
            ? this.previousFocus
            : document.querySelector('[data-nv-hero-signup] input');
          target?.focus({ preventScroll: true });
        }
      }

      onKeydown(event) {
        if (this.hidden) return;
        if (event.key !== 'Tab') return;
        const focusables = [...this.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]')]
          .filter(element => element.getClientRects().length > 0);
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (!focusables.includes(document.activeElement)) {
          event.preventDefault(); (event.shiftKey ? last : first).focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novariv-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.novariv-product__interest-form')) return;
    const tags = form.querySelector('[data-preorder-tags]');
    if (!tags) return;
    const gender = form.querySelector('[data-preorder-gender]')?.value;
    const age = form.querySelector('[data-preorder-age]')?.value;
    const size = form.querySelector('[data-preorder-size]')?.value;
    const additions = [];
    if (['male', 'female', 'prefer-not-to-say'].includes(gender)) additions.push('preorder-gender-' + gender);
    if (/^\d{2}$/.test(age) && Number(age) >= 18 && Number(age) <= 99) additions.push('preorder-age-' + age);
    if (['XS', 'S', 'M', 'L', 'XL'].includes(size)) additions.push('preorder-size-' + size);
    tags.value = ['newsletter', 'pre-access', 'hitodama-knit-interest', ...additions].join(', ');
  });

  class NovarivProductGallery extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-product-slide]'));
      this.thumbnails = Array.from(this.querySelectorAll('[data-product-thumbnail]'));
      this.status = this.querySelector('[data-product-status]');
      this.currentIndex = 0;
      this.querySelector('[data-product-previous]')?.addEventListener('click', () => this.show(this.currentIndex - 1));
      this.querySelector('[data-product-next]')?.addEventListener('click', () => this.show(this.currentIndex + 1));
      this.thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => this.show(Number(thumbnail.dataset.index)));
      });
    }

    show(nextIndex) {
      if (!this.slides.length) return;
      this.currentIndex = (nextIndex + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const active = index === this.currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.thumbnails.forEach((thumbnail, index) => {
        const active = index === this.currentIndex;
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-selected', String(active));
      });
      if (this.status) this.status.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
    }
  }

  class NovarivProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.variantInput = this.querySelector('[data-product-variant-id]');
      this.price = document.querySelector('[data-product-price]');
      this.button = this.querySelector('[data-product-add]');
      this.buttonLabel = this.querySelector('[data-product-add-label]');
      this.buttonPrice = this.querySelector('[data-product-button-price]');
      this.form?.addEventListener('submit', (event) => this.addToCart(event));
      this.querySelectorAll('[data-product-variant]').forEach((input) => {
        input.addEventListener('change', () => this.selectVariant(input));
      });
    }

    async addToCart(event) {
      event.preventDefault();
      if (!this.form || !this.button || this.button.disabled) return;

      this.button.disabled = true;

      try {
        const selectedVariant = this.querySelector('[data-product-variant]:checked');
        const variantId = selectedVariant?.value || this.variantInput?.value;
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
        });

        if (!response.ok) throw new Error('Unable to add this item to the cart.');
        window.location.assign(`${window.Shopify.routes.root}cart`);
      } catch (error) {
        console.error(error);
        this.button.disabled = false;
      }
    }

    selectVariant(input) {
      const available = input.dataset.available === 'true';
      this.variantInput.value = input.value;
      this.price.textContent = input.dataset.price;
      this.buttonPrice.textContent = input.dataset.price;
      this.button.disabled = !available;
      this.buttonLabel.textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
      document.dispatchEvent(
        new CustomEvent('novariv:variant-change', {
          detail: { title: input.dataset.title, price: input.dataset.price, available },
        })
      );
      const url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url);
    }
  }

  class NovarivStickyPurchase extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('[data-sticky-purchase-bar]');
      this.button = this.querySelector('[data-sticky-add]');
      this.mainButton = document.querySelector('[data-product-add]');
      this.variant = this.querySelector('[data-sticky-variant]');
      this.price = this.querySelector('[data-sticky-price]');

      if (!this.bar || !this.button || !this.mainButton) return;

      this.observer = new IntersectionObserver(([entry]) => {
        const hasPassed = entry.boundingClientRect.bottom < 0;
        this.bar.classList.toggle('is-visible', !entry.isIntersecting && hasPassed);
      });
      this.observer.observe(this.mainButton);
      this.button.addEventListener('click', () => this.mainButton.form?.requestSubmit(this.mainButton));
      document.addEventListener('novariv:variant-change', (event) => {
        this.variant.textContent = event.detail.title;
        this.price.textContent = event.detail.price;
        this.button.disabled = !event.detail.available;
      });
    }
  }

  if (!customElements.get('novariv-product-gallery')) {
    customElements.define('novariv-product-gallery', NovarivProductGallery);
  }
  if (!customElements.get('novariv-product-form')) {
    customElements.define('novariv-product-form', NovarivProductForm);
  }
  if (!customElements.get('novariv-sticky-purchase')) {
    customElements.define('novariv-sticky-purchase', NovarivStickyPurchase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novariv-video-hero"] && !Shopify.designMode) return;
  try {
    
  class NovarivVideoSequence extends HTMLElement {
    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('[data-novariv-sequence-video]'));
      if (!this.videos.length) return;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.currentIndex = 0;
      this.endedHandlers = new Map();

      this.videos.forEach((video, index) => {
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.controls = false;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.removeAttribute('controls');

        const endedHandler = () => this.advance(index);
        this.endedHandlers.set(video, endedHandler);
        video.addEventListener('ended', endedHandler);
        video.addEventListener('canplay', () => {
          if (index === this.currentIndex) this.tryPlayback();
        }, { once: true });
      });

      if (this.reducedMotion) {
        this.videos.forEach((video) => video.pause());
        return;
      }

      this.visibilityHandler = () => {
        if (!document.hidden) this.tryPlayback();
      };
      this.pageShowHandler = () => this.tryPlayback();
      this.interactionHandler = () => {
        this.tryPlayback();
        document.removeEventListener('touchstart', this.interactionHandler);
        document.removeEventListener('pointerdown', this.interactionHandler);
      };

      document.addEventListener('visibilitychange', this.visibilityHandler);
      window.addEventListener('pageshow', this.pageShowHandler);
      document.addEventListener('touchstart', this.interactionHandler, { once: true, passive: true });
      document.addEventListener('pointerdown', this.interactionHandler, { once: true, passive: true });
      requestAnimationFrame(() => this.tryPlayback());
    }

    disconnectedCallback() {
      this.endedHandlers?.forEach((handler, video) => video.removeEventListener('ended', handler));
      if (this.visibilityHandler) document.removeEventListener('visibilitychange', this.visibilityHandler);
      if (this.pageShowHandler) window.removeEventListener('pageshow', this.pageShowHandler);
      if (this.interactionHandler) {
        document.removeEventListener('touchstart', this.interactionHandler);
        document.removeEventListener('pointerdown', this.interactionHandler);
      }
    }

    tryPlayback() {
      if (this.reducedMotion) return;
      const currentVideo = this.videos?.[this.currentIndex];
      if (!currentVideo) return;
      currentVideo.muted = true;
      const playback = currentVideo.play();
      if (playback) playback.catch(() => {});
    }

    advance(index) {
      if (index !== this.currentIndex) return;
      const currentVideo = this.videos[this.currentIndex];
      currentVideo.classList.remove('is-active');
      currentVideo.currentTime = 0;
      this.currentIndex = (this.currentIndex + 1) % this.videos.length;
      const nextVideo = this.videos[this.currentIndex];
      nextVideo.currentTime = 0;
      nextVideo.classList.add('is-active');
      this.tryPlayback();
    }
  }

  if (!customElements.get('novariv-video-sequence')) {
    customElements.define('novariv-video-sequence', NovarivVideoSequence);
  }

  } catch(e) { console.error(e); }
})();
})();
